/* CREST | Premium Dual — theme JS
   Vanilla, no deps. Handles: splash memory, side tracking, cart drawer,
   quick-add, scroll reveals, sticky header, sticky ATC, announcement rotation,
   exit-intent popup, search overlay, mobile nav, custom cursor, toast. */
(function(){
'use strict';
const $ = (s,r=document)=>r.querySelector(s);
const $$ = (s,r=document)=>[...r.querySelectorAll(s)];
const on = (el,ev,fn,o)=>el&&el.addEventListener(ev,fn,o);
const storage = {
  get(k){try{const v=localStorage.getItem(k);if(!v)return null;const p=JSON.parse(v);if(p.exp&&p.exp<Date.now()){localStorage.removeItem(k);return null}return p.v}catch(e){return null}},
  set(k,v,days){const exp=days?Date.now()+days*864e5:0;try{localStorage.setItem(k,JSON.stringify({v,exp}))}catch(e){}},
  del(k){try{localStorage.removeItem(k)}catch(e){}}
};
window.CRESTstore = storage;

/* ——— Side tracking: her|him|none. Drives body[data-side] and side accent color */
const SIDE_KEY = 'crest_side';
window.CRESTgetSide = ()=> storage.get(SIDE_KEY) || document.body.dataset.side || '';
window.CRESTsetSide = (side, days=30)=>{
  if(!['her','him'].includes(side))return;
  storage.set(SIDE_KEY, side, days);
  document.body.dataset.side = side;
};
window.CRESTclearSide = ()=>{ storage.del(SIDE_KEY); delete document.body.dataset.side; location.reload(); };

/* ——— Announcement bar rotation */
(function annInit(){
  const el = $('.announcement__track'); if(!el) return;
  const items = $$('.announcement__item', el);
  if(items.length<2) return;
  // duplicate items for seamless loop
  items.forEach(i=>el.appendChild(i.cloneNode(true)));
})();

/* ——— Sticky header transparency toggle
   Rules: header is transparent ONLY when
     (a) the section setting allows it (data-transparent-over-hero), AND
     (b) there is a real [data-hero-over] element on this page, AND
     (c) the user has NOT scrolled past the bottom of that hero.
   On any page without a hero, header stays solid — always. */
(function headerInit(){
  const hdr = $('.site-header'); if(!hdr) return;
  const allowed = hdr.hasAttribute('data-transparent-over-hero');
  const hero = allowed ? document.querySelector('[data-hero-over]') : null;
  if(!allowed || !hero){
    hdr.classList.remove('is-transparent');
    return;
  }
  const solidify = ()=>{
    const rect = hero.getBoundingClientRect();
    const threshold = rect.bottom - 40;
    hdr.classList.toggle('is-transparent', threshold > 0);
  };
  solidify();
  on(window,'scroll',solidify,{passive:true});
  on(window,'resize',solidify);
})();

/* ——— Scroll reveal (with failsafe: force .in after 2.5s so content never stays hidden) */
(function revealInit(){
  const els = $$('[data-reveal], .stagger');
  const io = new IntersectionObserver(entries=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target) } });
  }, { threshold:.12, rootMargin:'0px 0px -40px 0px' });
  els.forEach(el=>{
    // If the element has no box (display:contents) or zero client rect, reveal immediately
    const rect = el.getBoundingClientRect();
    if(rect.width === 0 && rect.height === 0){ el.classList.add('in'); return }
    io.observe(el);
  });
  // Ultimate safety net — no element should ever stay hidden
  setTimeout(()=>{ els.forEach(el=>el.classList.add('in')) }, 2500);
})();

/* ——— Toast */
const toastEl = document.createElement('div');
toastEl.className = 'toast'; toastEl.setAttribute('role','status');
document.body.appendChild(toastEl);
let toastT;
window.CRESTtoast = (msg)=>{
  toastEl.textContent = msg; toastEl.classList.add('show');
  clearTimeout(toastT); toastT = setTimeout(()=>toastEl.classList.remove('show'),2400);
};

/* ——— Cart drawer */
const cartDrawer = {
  el: null, overlay: null,
  init(){
    this.el = $('#cart-drawer'); this.overlay = $('#cart-drawer-overlay');
    if(!this.el) return;
    on(this.overlay,'click',()=>this.close());
    $$('[data-cart-close]', this.el).forEach(b=>on(b,'click',()=>this.close()));
    $$('[data-cart-open]').forEach(b=>on(b,'click',(e)=>{e.preventDefault();this.open()}));
    document.addEventListener('keydown',(e)=>{ if(e.key==='Escape') this.close() });
    // Delegated on document so it works in the drawer AND on the full /cart page
    // (previously bound only to the drawer, leaving the cart-page buttons dead).
    document.addEventListener('click',(e)=>{
      const rm=e.target.closest('[data-line-remove]');
      const plus=e.target.closest('[data-line-plus]');
      const minus=e.target.closest('[data-line-minus]');
      const hit = rm||plus||minus; if(!hit) return;
      e.preventDefault();
      const onPage = !hit.closest('#cart-drawer'); // full cart page vs drawer
      // Read the live quantity from the adjacent input, not the stale data-qty,
      // so rapid clicks accumulate correctly instead of repeating the baked value.
      const wrap = hit.closest('.qty');
      const input = wrap && wrap.querySelector('input');
      const cur = input ? (parseInt(input.value,10)||0) : (parseInt(hit.dataset.qty,10)||0);
      const q = rm ? 0 : (plus ? cur+1 : Math.max(0, cur-1));
      if(input && !rm) input.value = q; // optimistic, so the next click reads the new value
      this.updateQty(hit.dataset.lineKey, q, onPage);
    });
  },
  open(){ this.el.classList.add('is-open'); this.overlay.classList.add('is-open'); document.body.style.overflow='hidden'; this.refresh(); },
  close(){ this.el.classList.remove('is-open'); this.overlay.classList.remove('is-open'); document.body.style.overflow=''; },
  async refresh(){
    try{
      const r = await fetch('/cart?view=drawer');
      const t = await r.text();
      const here = $('#cart-drawer-body');
      if(here){ here.innerHTML = t }
      this.updateCount();
    }catch(e){}
  },
  async updateCount(){
    try{ const r = await fetch('/cart.js'); const j = await r.json();
      $$('[data-cart-count]').forEach(el=>{ el.textContent = j.item_count; el.classList.toggle('hide', j.item_count===0) });
    }catch(e){}
  },
  async add(id, qty=1, props={}){
    try{
      const r = await fetch('/cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{id:Number(id), quantity:qty, properties: props}] })
      });
      const j = await r.json();
      if(r.ok){ window.CRESTtoast('Added to bag'); this.open(); return true; }
      window.CRESTtoast(j.description || 'Unavailable'); return false;
    }catch(e){ window.CRESTtoast('Try again'); return false; }
  },
  async updateQty(key, qty, reload){
    try{
      const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
      if(!r.ok){ const j = await r.json().catch(()=>({})); window.CRESTtoast(j.description || 'Could not update quantity'); }
      // Re-sync the UI to the server's real cart either way — this also corrects
      // the optimistic input value if the change was rejected (e.g. not enough stock).
      if(reload){ window.location.reload(); } else { this.refresh(); }
    }catch(e){ window.CRESTtoast('Try again'); if(reload){ window.location.reload(); } else { this.refresh(); } }
  }
};
cartDrawer.init();
window.CRESTcart = cartDrawer;

/* ——— Quick-add */
document.addEventListener('click',(e)=>{
  const btn = e.target.closest('[data-quick-add]'); if(!btn) return;
  e.preventDefault();
  const id = btn.dataset.variantId; if(!id) return;
  btn.disabled = true; const orig = btn.textContent; btn.textContent = 'Adding…';
  cartDrawer.add(id,1).finally(()=>{ btn.disabled=false; btn.textContent = orig });
});

/* ——— PDP option picker initial soldout sync (handles stale page-cache HTML) */
(function pdpSoldoutInit(){
  document.querySelectorAll('form [data-variants]').forEach(node => {
    const form = node.closest('form'); if(!form) return;
    let data; try{ data = JSON.parse(node.textContent); }catch(e){ return; }
    const groups = $$('[data-option-group]', form);
    groups.forEach(g => {
      const giAttr = g.dataset.optionIndex;
      const gi = giAttr != null ? parseInt(giAttr, 10) : groups.indexOf(g);
      $$('button', g).forEach(b => {
        const v = b.dataset.optionValue;
        // Union availability on landing: a value is sold out only if NO variant
        // carrying it is in stock. Keeps the default color from hiding sizes that
        // other colors have. Per-color narrowing happens on swatch selection.
        const anyAvail = data.some(vv => vv.options[gi] === v && vv.available);
        if (!anyAvail) b.setAttribute('data-soldout','');
        else b.removeAttribute('data-soldout');
      });
    });
  });
})();

/* ——— PDP option picker (size/color) */
document.addEventListener('click',(e)=>{
  const pill = e.target.closest('.opt-pills button, .swatch-pills button'); if(!pill) return;
  if(pill.hasAttribute('data-soldout')) return;
  const group = pill.closest('[data-option-group]'); if(!group) return;
  $$('button',group).forEach(b=>b.setAttribute('aria-checked','false'));
  pill.setAttribute('aria-checked','true');
  const form = pill.closest('form'); if(!form) return;
  const name = group.dataset.optionName;
  const labelSpan = group.querySelector('[data-option-selected]');
  if(labelSpan) labelSpan.textContent = pill.dataset.optionValue;

  // Scroll PDP gallery to this swatch's media (desktop thumbs OR mobile carousel)
  const scrollGalleryTo = (mediaId)=>{
    if(!mediaId) return;
    // Desktop thumbnails layout
    if(window.CREST_SYNC_THUMBS){ window.CREST_SYNC_THUMBS(mediaId); }
    // Mobile carousel: use direct scrollLeft (more reliable than scrollIntoView)
    const mobCar = document.querySelector('[data-pdp-gallery-mobile]');
    const mobSlide = mobCar && mobCar.querySelector(`[data-media-id="${mediaId}"]`);
    if(mobCar && mobSlide){
      const target = mobSlide.offsetLeft - mobCar.offsetLeft;
      mobCar.scrollTo({left: target, behavior:'smooth'});
      const idx = parseInt(mobSlide.dataset.slideIndex || 0, 10);
      // update mobile thumbs active state + scroll them into view
      $$('[data-m-thumb]').forEach((t,ti)=>{
        const active = ti===idx;
        t.classList.toggle('is-active', active);
        if(active) t.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
      });
      $$('.pdp__dot').forEach((d,di)=>d.setAttribute('aria-current', di===idx ? 'true' : 'false'));
    }
    // Desktop non-thumbs layouts (grid/stacked)
    const deskSlide = document.querySelector(`[data-pdp-gallery]:not([data-gallery-thumbs]) [data-media-id="${mediaId}"]`);
    if(deskSlide){
      deskSlide.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
    }
  };
  if(pill.dataset.mediaId) scrollGalleryTo(pill.dataset.mediaId);

  // ——— Size-first auto color-switch: if a SIZE pill was clicked and the
  // currently shown color has no stock for it, switch to a color that does, so
  // the union-available sizes shown on landing never dead-end on an OOS color.
  try{
    const _data = JSON.parse(form.querySelector('[data-variants]').textContent);
    const _groups = $$('[data-option-group]', form);
    const _colorGroup = _groups.find(g => /colou?r/i.test(g.dataset.optionName || ''));
    if(_colorGroup && group !== _colorGroup){
      const _ci = parseInt(_colorGroup.dataset.optionIndex, 10);
      const _sel = _groups.map(g => { const s=g.querySelector('[aria-checked="true"]'); return s ? s.dataset.optionValue : null; });
      const _cur = _data.find(v => v.options.every((o,i)=> o===_sel[i]));
      if(!_cur || !_cur.available){
        // available variant matching every non-color selection + this size
        const _alt = _data.find(v => v.available && v.options.every((o,i)=> i===_ci || o===_sel[i]));
        if(_alt){
          const _newColor = _alt.options[_ci];
          const _cp = $$('button', _colorGroup).find(b => b.dataset.optionValue === _newColor);
          if(_cp){
            $$('button', _colorGroup).forEach(b=>b.setAttribute('aria-checked','false'));
            _cp.setAttribute('aria-checked','true');
            const _cl = _colorGroup.querySelector('[data-option-selected]');
            if(_cl) _cl.textContent = _newColor;
            if(_cp.dataset.mediaId) scrollGalleryTo(_cp.dataset.mediaId);
          }
        }
      }
    }
  }catch(_e){}

  // re-resolve variant
  const current = $$('[data-option-group]',form).map(g=>{
    const sel = g.querySelector('[aria-checked="true"]'); return sel ? sel.dataset.optionValue : null;
  });
  try{
    const data = JSON.parse(form.querySelector('[data-variants]').textContent);
    // Cross-group soldout sync: re-evaluate data-soldout on the OTHER option
    // groups now that this group's value changed. A pill is sold-out if no
    // available variant exists for (this pill's value + selections in every
    // other group). Without this, e.g. switching color leaves size pills with
    // a stale soldout state baked at SSR from a different color.
    $$('[data-option-group]', form).forEach(g => {
      if (g === group) return;
      const giAttr = g.dataset.optionIndex;
      const gi = giAttr != null ? parseInt(giAttr, 10) : $$('[data-option-group]', form).indexOf(g);
      $$('button', g).forEach(b => {
        const v = b.dataset.optionValue;
        const m = data.find(vv => {
          if (vv.options[gi] !== v) return false;
          for (let i = 0; i < vv.options.length; i++) {
            if (i === gi) continue;
            if (vv.options[i] !== current[i]) return false;
          }
          return true;
        });
        if (!m || !m.available) b.setAttribute('data-soldout','');
        else b.removeAttribute('data-soldout');
      });
    });
    const match = data.find(v => v.options.every((o,i)=> o===current[i]));
    if(match){
      form.querySelector('[name="id"]').value = match.id;
      const price = form.querySelector('[data-pdp-price]');
      if(price){
        const money = CRESTmoney(match.price);
        let html = `<span>${money}</span>`;
        if(match.compare_at_price && match.compare_at_price > match.price){
          const off = Math.round((match.compare_at_price-match.price)/match.compare_at_price*100);
          html = `<span>${money}</span> <del>${CRESTmoney(match.compare_at_price)}</del> <span class="save">Save ${off}%</span>`;
        }
        price.innerHTML = html;
      }
      const atc = form.querySelector('[data-atc]');
      if(atc){ atc.disabled = !match.available; atc.textContent = match.available ? atc.dataset.labelIn : 'Sold out' }
      const skuEl = form.querySelector('[data-pdp-sku]');
      if(skuEl){
        skuEl.textContent = match.sku || '';
        const skuWrap = skuEl.closest('.pdp__sku');
        if(skuWrap) skuWrap.classList.toggle('hide', !match.sku);
      }
      const stockEl = form.querySelector('[data-low-stock]');
      if(stockEl){
        const n = Number(stockEl.dataset.threshold || 5);
        const inv = match.inventory_quantity;
        const show = match.available && Number.isFinite(inv) && inv>0 && inv<=n;
        stockEl.classList.toggle('hide',!show);
        if(show) stockEl.innerHTML = stockEl.dataset.template.replace('__N__', inv);
      }
      // also sync gallery to variant's featured_media even if pill didn't carry media id
      if(!pill.dataset.mediaId && match.featured_media_id) scrollGalleryTo(match.featured_media_id);

      // ABSOLUTE FALLBACK: if the variant has a featured_image URL, swap the
      // main images directly — covers cases where variant has an image but no
      // matching slide/thumb (e.g. image isn't assigned as product media).
      if(match.featured_image){
        // Desktop thumbs layout main image
        const deskMain = document.querySelector('[data-pdp-main]');
        if(deskMain){
          deskMain.removeAttribute('srcset');
          deskMain.setAttribute('src', match.featured_image);
          if(match.featured_image_srcset) deskMain.setAttribute('srcset', match.featured_image_srcset);
        }
        // Sticky ATC thumb
        const stk = document.querySelector('[data-sticky-img] img');
        if(stk && match.featured_image_thumb) stk.src = match.featured_image_thumb;
      }
    }
  }catch(err){}
});

/* ——— Money formatter (fallback, uses shop currency) */
window.CRESTmoney = function(cents){
  const n = Number(cents)/100;
  try{ return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency: window.CREST_CURRENCY||'EGP',maximumFractionDigits:0}).format(n) }
  catch(e){ return n.toFixed(0) + ' ' + (window.CREST_CURRENCY||'EGP') }
};

/* ——— Sticky ATC */
(function stickyAtcInit(){
  const bar = $('#sticky-atc'); if(!bar) return;
  const anchor = $('#pdp-atc-anchor'); if(!anchor) return;
  const io = new IntersectionObserver(([e])=>{
    bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top<0);
  },{ threshold:0 });
  io.observe(anchor);
})();

/* ——— PDP ATC submit */
document.addEventListener('submit',(e)=>{
  const f = e.target.closest('[data-product-form]'); if(!f) return;
  e.preventDefault();
  const id = f.querySelector('[name="id"]').value;
  const qty = parseInt((f.querySelector('[name="quantity"]')||{value:1}).value,10)||1;
  const btn = f.querySelector('[data-atc]'); if(btn){ btn.disabled=true; const t=btn.textContent; btn.textContent='Adding…';
    cartDrawer.add(id,qty).finally(()=>{ btn.disabled=false; btn.textContent=t });
  }
});

/* ——— PDP "Buy it now": add variant then go straight to /checkout */
document.addEventListener('click',(e)=>{
  const btn = e.target.closest('[data-buy-now]'); if(!btn) return;
  e.preventDefault();
  if(btn.disabled) return;
  const form = btn.closest('form'); if(!form) return;
  const id = form.querySelector('[name="id"]').value;
  const qty = parseInt((form.querySelector('[name="quantity"]')||{value:1}).value,10)||1;
  const orig = btn.textContent;
  btn.disabled = true; btn.textContent = 'Processing…';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ items:[{id: Number(id), quantity: qty}] })
  }).then(r => r.ok ? (window.location.href = '/checkout') :
      r.json().then(j => { window.CRESTtoast && CRESTtoast(j.description || 'Unavailable'); btn.disabled = false; btn.textContent = orig })
  ).catch(() => { btn.disabled = false; btn.textContent = orig; window.CRESTtoast && CRESTtoast('Try again') });
});

/* ——— Mobile nav */
(function mobileNavInit(){
  const btn = $('[data-mobile-open]'); const nav = $('#mobile-nav'); const close = $('[data-mobile-close]');
  if(!btn||!nav) return;
  on(btn,'click',()=>{ nav.classList.add('is-open'); document.body.style.overflow='hidden' });
  on(close,'click',()=>{ nav.classList.remove('is-open'); document.body.style.overflow='' });
})();

/* ——— Search overlay */
(function searchInit(){
  const trig = $('[data-search-open]'); const ov = $('#search-overlay'); const close = $('[data-search-close]');
  if(!trig||!ov) return;
  on(trig,'click',(e)=>{ e.preventDefault(); ov.classList.add('is-open'); setTimeout(()=>ov.querySelector('input').focus(),120) });
  on(close,'click',()=>ov.classList.remove('is-open'));
  on(ov,'click',(e)=>{ if(e.target===ov) ov.classList.remove('is-open') });
})();

/* ——— Exit-intent popup (desktop only, once per session) */
(function exitIntentInit(){
  const pop = $('#exit-intent'); if(!pop) return;
  if(!window.matchMedia('(hover:hover)').matches) return;
  if(sessionStorage.getItem('crest_exit_shown')) return;
  if(storage.get('crest_newsletter_done')) return;
  let armed = false; setTimeout(()=>armed=true, 20000); // wait 20s
  on(document,'mouseleave',(e)=>{
    if(!armed) return;
    if(e.clientY>20) return;
    sessionStorage.setItem('crest_exit_shown','1');
    pop.classList.add('is-open');
  });
  $$('[data-popup-close]',pop).forEach(b=>on(b,'click',()=>pop.classList.remove('is-open')));
  on(pop,'click',(e)=>{ if(e.target===pop) pop.classList.remove('is-open') });
  const form = pop.querySelector('form'); if(form) on(form,'submit',(e)=>{
    e.preventDefault();
    const code = pop.dataset.code || 'STAY10';
    pop.querySelector('.popup__code').textContent = code;
    pop.querySelector('.popup__code').classList.remove('hide');
    storage.set('crest_newsletter_done', 1, 365);
  });
})();

/* ——— Custom cursor (splash only) */
(function cursorInit(){
  if(!window.matchMedia('(hover:hover)').matches) return;
  if(!document.body.classList.contains('enable-cursor')) return;
  const c = document.createElement('div'); c.className='crest-cursor'; document.body.appendChild(c);
  let x=0,y=0,tx=0,ty=0;
  on(window,'mousemove',(e)=>{tx=e.clientX;ty=e.clientY;c.classList.add('active')});
  (function loop(){x+=(tx-x)*.18;y+=(ty-y)*.18;c.style.transform=`translate(${x}px,${y}px) translate(-50%,-50%)`;requestAnimationFrame(loop)})();
  $$('.splash__side').forEach(s=>{
    on(s,'mouseenter',()=>c.classList.add('grow'));
    on(s,'mouseleave',()=>c.classList.remove('grow'));
  });
})();

/* ——— PDP gallery dots (mobile swipeable) */
(function galleryDotsInit(){
  const gal = $('[data-pdp-gallery-mobile]') || $('[data-pdp-gallery]'); const dots = $('[data-pdp-dots]');
  if(!gal || !dots) return;
  const slides = $$('.pdp__slide', gal);
  const dotEls = $$('.pdp__dot', dots);
  if(slides.length < 2) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting && e.intersectionRatio > .6){
        const i = parseInt(e.target.dataset.slideIndex, 10);
        dotEls.forEach((d,di)=>d.setAttribute('aria-current', di===i ? 'true' : 'false'));
      }
    });
  }, { root: gal, threshold: [.6, .9] });
  slides.forEach(s=>io.observe(s));
  dotEls.forEach((d, di)=>on(d,'click',()=>{
    const s = slides[di]; if(s) s.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
  }));
  if(dotEls[0]) dotEls[0].setAttribute('aria-current','true');
})();

/* ——— PDP mobile: horizontal thumbnails under the swipeable main carousel */
(function mobileThumbsInit(){
  const car = $('[data-pdp-gallery-mobile]');
  const thumbs = $('[data-pdp-thumbs-mobile]');
  if(!car || !thumbs) return;
  const slides = $$('.pdp__slide', car);
  const thumbEls = $$('[data-m-thumb]', thumbs);
  const prev = $('[data-m-thumb-prev]', thumbs);
  const next = $('[data-m-thumb-next]', thumbs);
  if(slides.length < 2){ thumbs.style.display = 'none'; return }

  function setActive(i){
    thumbEls.forEach((t,ti)=>t.classList.toggle('is-active', ti===i));
    const active = thumbEls[i];
    if(active) active.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
  }
  function findActive(){
    let i = 0;
    thumbEls.forEach((t, ti)=>{ if(t.classList.contains('is-active')) i = ti });
    return i;
  }
  function goto(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    const s = slides[i]; if(s) s.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
  }

  thumbEls.forEach(t=>on(t,'click',(e)=>{
    e.preventDefault();
    const i = Number(t.dataset.slideIndex);
    setActive(i); goto(i);
  }));

  // Sync: which main slide is in view → mark its thumb active
  const io = new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting && e.intersectionRatio > .6){
        const i = parseInt(e.target.dataset.slideIndex || 0, 10);
        setActive(i);
      }
    });
  }, { root: car, threshold: [.6, .9] });
  slides.forEach(s=>io.observe(s));

  // Left/right arrows
  on(prev,'click',()=>{ const i = findActive()-1; if(i>=0){ setActive(i); goto(i) } else { prev.animate([{transform:'scale(.85)'},{transform:'scale(1)'}],{duration:180}) } });
  on(next,'click',()=>{ const i = findActive()+1; if(i<slides.length){ setActive(i); goto(i) } else { next.animate([{transform:'scale(.85)'},{transform:'scale(1)'}],{duration:180}) } });

  // Initial state
  setActive(0);
})();

/* ——— PDP thumbnails gallery: click to swap main, up/down arrows scroll list */
(function thumbsInit(){
  const wrap = $('[data-gallery-thumbs]'); if(!wrap) return;
  const list = $('[data-thumbs-list]', wrap);
  const main = $('[data-pdp-main]', wrap);
  const thumbs = $$('[data-thumb]', wrap);
  const upBtn = $('[data-thumbs-up]', wrap);
  const dnBtn = $('[data-thumbs-down]', wrap);

  function swap(t, scrollMainIntoView){
    if(!t) return;
    thumbs.forEach(x=>x.classList.toggle('is-active', x===t));
    const src = t.dataset.full;
    const srcset = t.dataset.fullSrcset;
    if(main && src){
      main.removeAttribute('srcset');
      main.setAttribute('src', src);
      if(srcset) main.setAttribute('srcset', srcset);
    }
    // ensure the thumb is scrolled into view in its vertical list
    t.scrollIntoView({block:'nearest', behavior:'smooth'});
  }

  // click a thumb
  thumbs.forEach(t=>on(t,'click',(e)=>{ e.preventDefault(); swap(t); }));

  // arrows
  const THUMB_STEP = 100;
  on(upBtn,'click',()=> list && list.scrollBy({top:-THUMB_STEP, behavior:'smooth'}));
  on(dnBtn,'click',()=> list && list.scrollBy({top: THUMB_STEP, behavior:'smooth'}));
  function updateArrowState(){
    if(!upBtn || !dnBtn || !list) return;
    upBtn.disabled = list.scrollTop <= 2;
    dnBtn.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
  }
  updateArrowState();
  on(list,'scroll',updateArrowState,{passive:true});

  // when a color swatch changes the variant, sync the main image to that variant's media
  window.CREST_SYNC_THUMBS = function(mediaId){
    const t = thumbs.find(x => x.dataset.mediaId == String(mediaId));
    if(t) swap(t);
  };
})();

/* ——— Sticky ATC price/image sync with variant pick */
(function stickyAtcSync(){
  const form = $('[data-product-form]'); const bar = $('#sticky-atc'); if(!form || !bar) return;
  const priceEl = bar.querySelector('[data-sticky-price]');
  const imgEl = bar.querySelector('[data-sticky-img] img');
  let variants = [];
  try{ variants = JSON.parse(form.querySelector('[data-variants]').textContent); }catch(e){}
  const observer = new MutationObserver(()=>{
    const id = Number(form.querySelector('[name="id"]').value);
    const v = variants.find(x=>x.id===id); if(!v) return;
    if(priceEl) priceEl.textContent = CRESTmoney(v.price);
    if(imgEl && v.featured_image){ imgEl.src = v.featured_image; }
    const buy = bar.querySelector('[data-sticky-buy]'); if(buy){ buy.classList.toggle('is-disabled', !v.available); buy.textContent = v.available ? buy.textContent : 'Sold out'; }
  });
  observer.observe(form.querySelector('[name="id"]'), { attributes: true, attributeFilter: ['value'] });
})();

/* ——— Mobile bottom nav: set active state by path */
(function bnavInit(){
  const nav = $('.mobile-bnav'); if(!nav) return;
  const path = location.pathname;
  $$('a', nav).forEach(a=>{
    const href = a.getAttribute('href') || '';
    const base = href.split('?')[0].replace(/\/$/, '');
    const cur = path.replace(/\/$/, '');
    if(base === '/' && cur === '') a.classList.add('is-active');
    else if(base !== '/' && base !== '' && cur.startsWith(base)) a.classList.add('is-active');
  });
})();

/* ——— Card: on mobile, move .card__sizes to the bottom of the card
   (after colors) so it appears below the swatches instead of overlaying
   the image. On desktop, it stays inside .card__media so the hover-overlay
   behaviour works as before. */
(function cardSizesReorder(){
  const MQ = window.matchMedia('(max-width: 960px)');
  function apply(){
    const mobile = MQ.matches;
    $$('.card').forEach(card=>{
      const sizes = card.querySelector('.card__sizes'); if(!sizes) return;
      const media = card.querySelector('.card__media'); if(!media) return;
      if(mobile){
        if(sizes.parentElement !== card){
          card.appendChild(sizes);
          sizes.dataset.placement = 'mobile';
        }
      } else {
        if(sizes.dataset.placement === 'mobile'){
          media.appendChild(sizes);
          delete sizes.dataset.placement;
        }
      }
    });
  }
  apply();
  // react to viewport changes (responsive testing / device rotation)
  if(MQ.addEventListener) MQ.addEventListener('change', apply);
  else if(MQ.addListener) MQ.addListener(apply);
})();

/* ——— Card: color swatch swaps card image + sets current color
   Bulletproof: update srcset BEFORE src, via setAttribute, so browsers that
   prefer srcset don't keep rendering the old variant image. */
function _CRESTswapCardImg(card, sw){
  const img = card.querySelector('[data-card-img]');
  if(!img) return false;
  const newSrc = sw.dataset.img;
  if(!newSrc) return false;
  if(!img.dataset.origSrc){
    img.dataset.origSrc    = img.getAttribute('src')    || '';
    img.dataset.origSrcset = img.getAttribute('srcset') || '';
  }
  const newSrcset = sw.dataset.imgSrcset || '';
  // 1) nuke the current srcset so the browser's responsive picker forgets the old URLs
  img.removeAttribute('srcset');
  // 2) swap the src
  img.setAttribute('src', newSrc);
  // 3) re-attach the new srcset (if provided) — browser re-evaluates now pointing at new variant
  if(newSrcset) img.setAttribute('srcset', newSrcset);
  return true;
}
function _CRESTrevertCardImg(card){
  if(card.dataset.colorLocked === '1') return;
  const img = card.querySelector('[data-card-img]');
  if(!img || !img.dataset.origSrc) return;
  img.removeAttribute('srcset');
  img.setAttribute('src', img.dataset.origSrc);
  if(img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
}
function _CRESTsyncCardSizesForColor(card, color){
  const variantsScript = card.querySelector('[data-card-variants]');
  if(!variantsScript) return;
  let variants;
  try{ variants = JSON.parse(variantsScript.textContent); }catch(_){ return; }
  const sizeIdx  = Number(card.dataset.sizeIdx  ?? 1);
  const colorIdx = Number(card.dataset.colorIdx ?? 0);
  $$('[data-card-size]', card).forEach(pill=>{
    const size = pill.dataset.sizeValue;
    const m = variants.find(v => v.options[colorIdx] === color && v.options[sizeIdx] === size);
    if(m){
      pill.dataset.variantId = m.id;
      pill.classList.toggle('is-soldout', !m.available);
    } else {
      pill.removeAttribute('data-variant-id');
      pill.classList.add('is-soldout');
    }
  });
}
// Union resting state for the grid: a size is sold out only if NO color carries
// it in stock. data-variant-id points to an in-stock variant (current color
// preferred) so a click adds a valid one even if the shown color lacks the size.
function _CRESTcardSizesUnion(card){
  const tag = card.querySelector('[data-card-variants]'); if(!tag) return;
  let variants; try{ variants = JSON.parse(tag.textContent); }catch(_){ return; }
  const sizeIdx  = Number(card.dataset.sizeIdx  ?? 1);
  const colorIdx = Number(card.dataset.colorIdx ?? 0);
  const cur = card.dataset.currentColor || null;
  $$('[data-card-size]', card).forEach(pill=>{
    const size = pill.dataset.sizeValue;
    const anyAvail = variants.some(v => v.options[sizeIdx] === size && v.available);
    pill.classList.toggle('is-soldout', !anyAvail);
    if(anyAvail){
      let pick = cur && variants.find(v => v.options[colorIdx]===cur && v.options[sizeIdx]===size && v.available);
      if(!pick) pick = variants.find(v => v.options[sizeIdx]===size && v.available);
      if(pick) pill.dataset.variantId = pick.id;
    }
  });
}
(function cardSizesInitUnion(){
  $$('.card[data-card]').forEach(c=>{ if(c.querySelector('[data-card-variants]')) _CRESTcardSizesUnion(c); });
})();

document.addEventListener('click',(e)=>{
  const sw = e.target.closest('[data-card-color]'); if(!sw) return;
  e.preventDefault();
  const card = sw.closest('.card'); if(!card) return;
  const color = sw.dataset.colorValue;
  card.dataset.currentColor = color;
  card.dataset.colorLocked = '1';
  $$('[data-card-color]', card).forEach(el=>el.classList.toggle('is-active', el===sw));
  _CRESTswapCardImg(card, sw);
  // after a click, treat the new image as the base so hover-revert doesn't undo it
  const img = card.querySelector('[data-card-img]');
  if(img){
    img.dataset.origSrc    = img.getAttribute('src')    || '';
    img.dataset.origSrcset = img.getAttribute('srcset') || '';
  }
  _CRESTsyncCardSizesForColor(card, color);
});

/* Hover preview on desktop — swap image AND update size pills */
if(window.matchMedia('(hover:hover)').matches){
  document.addEventListener('mouseover',(e)=>{
    const sw = e.target.closest('[data-card-color]'); if(!sw) return;
    const card = sw.closest('.card'); if(!card) return;
    _CRESTswapCardImg(card, sw);
    _CRESTsyncCardSizesForColor(card, sw.dataset.colorValue);
  });
  document.addEventListener('mouseout',(e)=>{
    const sw = e.target.closest('[data-card-color]'); if(!sw) return;
    const card = sw.closest('.card'); if(!card) return;
    if(!sw.classList.contains('is-active')){
      _CRESTrevertCardImg(card);
      if(card.dataset.colorLocked === '1'){
        const active = card.querySelector('[data-card-color].is-active');
        const baseColor = (active && active.dataset.colorValue) || card.dataset.currentColor;
        if(baseColor) _CRESTsyncCardSizesForColor(card, baseColor);
      } else {
        // No deliberate swatch click yet → keep the union resting state so a
        // hover-preview doesn't leave the initial color's sold-outs behind.
        _CRESTcardSizesUnion(card);
      }
    }
  });
}

/* ——— Card: size pill adds that specific variant */
document.addEventListener('click',(e)=>{
  const pill = e.target.closest('[data-card-size]'); if(!pill) return;
  e.preventDefault();
  if(pill.classList.contains('is-soldout')) return;
  const id = pill.dataset.variantId; if(!id) return;
  const card = pill.closest('.card');
  cartDrawer.add(id, 1).then(ok=>{
    if(!ok) return; // add failed (sold out / error) — don't show a false "added" tick
    $$('[data-card-size]', card).forEach(p=>p.classList.remove('is-added'));
    pill.classList.add('is-added');
    setTimeout(()=>pill.classList.remove('is-added'), 1500);
  });
});

/* ——— Card: bag → quick-add panel */
function _CRESTqaVariants(card){
  const tag = card.querySelector('script[data-card-variants]');
  if(!tag) return null;
  try{ return JSON.parse(tag.textContent); }catch(_){ return null; }
}
function _CRESTqaCurrent(card){
  const variants = _CRESTqaVariants(card); if(!variants) return null;
  const sizeIdx  = Number(card.dataset.sizeIdx  || 0);
  const colorIdx = Number(card.dataset.colorIdx || 0);
  const sizeBtn  = card.querySelector('[data-qa-size].is-active');
  const colorBtn = card.querySelector('[data-qa-color].is-active');
  const size  = sizeBtn  ? sizeBtn.dataset.sizeValue   : undefined;
  const color = colorBtn ? colorBtn.dataset.colorValue : undefined;
  return variants.find(v =>
    (size  === undefined || v.options[sizeIdx]  === size) &&
    (color === undefined || v.options[colorIdx] === color)
  );
}
function _CRESTqaSync(card){
  const v = _CRESTqaCurrent(card);
  const addBtn = card.querySelector('[data-qa-add]'); if(!addBtn) return;
  if(v){
    addBtn.dataset.variantId = v.id;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add' : 'Sold out';
  } else {
    addBtn.dataset.variantId = '';
    addBtn.disabled = true;
    addBtn.textContent = 'Unavailable';
  }
  // mark soldout pills for current color
  const variants = _CRESTqaVariants(card);
  if(variants){
    const colorIdx = Number(card.dataset.colorIdx || 0);
    const sizeIdx  = Number(card.dataset.sizeIdx  || 0);
    const colorBtn = card.querySelector('[data-qa-color].is-active');
    const color = colorBtn ? colorBtn.dataset.colorValue : null;
    $$('[data-qa-size]', card).forEach(p=>{
      const size = p.dataset.sizeValue;
      const m = variants.find(x => (color === null || x.options[colorIdx] === color) && x.options[sizeIdx] === size);
      p.classList.toggle('is-soldout', !!(m && !m.available));
    });
  }
}
document.addEventListener('click',(e)=>{
  const open = e.target.closest('[data-card-bag]');
  if(open){
    e.preventDefault();
    const card = open.closest('.card'); if(!card) return;
    const panel = card.querySelector('[data-card-qa]');
    if(panel) panel.removeAttribute('hidden');
    card.classList.add('is-qa-open');
    _CRESTqaSync(card);
    return;
  }
  const cancel = e.target.closest('[data-qa-cancel]');
  if(cancel){
    e.preventDefault();
    const card = cancel.closest('.card'); if(!card) return;
    card.classList.remove('is-qa-open');
    return;
  }
  const sp = e.target.closest('[data-qa-size]');
  if(sp){
    e.preventDefault();
    if(sp.classList.contains('is-soldout')) return;
    const card = sp.closest('.card'); if(!card) return;
    $$('[data-qa-size]', card).forEach(b=>b.classList.toggle('is-active', b===sp));
    const lbl = card.querySelector('[data-qa-size-current]');
    if(lbl) lbl.textContent = sp.dataset.sizeValue;
    _CRESTqaSync(card);
    return;
  }
  const cp = e.target.closest('[data-qa-color]');
  if(cp){
    e.preventDefault();
    const card = cp.closest('.card'); if(!card) return;
    $$('[data-qa-color]', card).forEach(b=>b.classList.toggle('is-active', b===cp));
    const lbl = card.querySelector('[data-qa-color-current]');
    if(lbl) lbl.textContent = cp.dataset.colorValue;
    _CRESTqaSync(card);
    return;
  }
  const dec = e.target.closest('[data-qa-qty-dec]');
  if(dec){
    e.preventDefault();
    const card = dec.closest('.card'); if(!card) return;
    const inp = card.querySelector('[data-qa-qty]'); if(!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value,10)||1) - 1);
    return;
  }
  const inc = e.target.closest('[data-qa-qty-inc]');
  if(inc){
    e.preventDefault();
    const card = inc.closest('.card'); if(!card) return;
    const inp = card.querySelector('[data-qa-qty]'); if(!inp) return;
    inp.value = Math.min(99, (parseInt(inp.value,10)||1) + 1);
    return;
  }
  const add = e.target.closest('[data-qa-add]');
  if(add){
    e.preventDefault();
    if(add.disabled) return;
    const card = add.closest('.card'); if(!card) return;
    const id = add.dataset.variantId; if(!id) return;
    const inp = card.querySelector('[data-qa-qty]');
    const qty = Math.max(1, parseInt(inp && inp.value || '1', 10) || 1);
    add.disabled = true;
    const orig = add.textContent;
    add.textContent = 'Adding…';
    cartDrawer.add(id, qty).then(()=>{
      card.classList.remove('is-qa-open');
    }).finally(()=>{
      add.disabled = false;
      add.textContent = orig;
    });
    return;
  }
});

/* ——— Quick View modal */
const qvModal = {
  el: null, closeBtn: null,
  state: { product:null, selected:{} },
  init(){
    this.el = $('#qv'); if(!this.el) return;
    this.closeBtn = $('[data-qv-close]', this.el);
    on(this.closeBtn,'click',()=>this.close());
    on(this.el,'click',(e)=>{ if(e.target===this.el) this.close() });
    document.addEventListener('keydown',(e)=>{ if(e.key==='Escape' && this.el.classList.contains('is-open')) this.close() });
    on($('[data-qv-atc]', this.el),'click',()=>this.add());
    // option clicks delegated
    on($('[data-qv-opts]', this.el),'click',(e)=>{
      const pill = e.target.closest('button[data-qv-opt]'); if(!pill) return;
      const name = pill.dataset.optName; const val = pill.dataset.optVal;
      this.state.selected[name] = val;
      $$('button[data-qv-opt]', this.el).forEach(b=>{
        if(b.dataset.optName===name) b.setAttribute('aria-checked', b.dataset.optVal===val ? 'true':'false');
      });
      this.updateSelectedVariant();
    });
  },
  async open(handle){
    if(!this.el) return;
    this.el.classList.add('is-open');
    document.body.style.overflow='hidden';
    try{
      const r = await fetch(`/products/${handle}.js`);
      const p = await r.json();
      this.state.product = p;
      this.state.selected = {};
      p.options.forEach((n,i)=>{ this.state.selected[n] = (p.variants[0]||{}).options[i]; });
      this.render();
    }catch(e){ this.close() }
  },
  close(){ this.el.classList.remove('is-open'); document.body.style.overflow='' },
  render(){
    const p = this.state.product; if(!p) return;
    $('[data-qv-image]', this.el).src = p.featured_image || p.images[0] || '';
    $('[data-qv-image]', this.el).alt = p.title || '';
    $('[data-qv-vendor]', this.el).textContent = p.vendor || '';
    $('[data-qv-title]', this.el).textContent = p.title || '';
    $('[data-qv-link]', this.el).href = p.url;
    this.renderPrice();
    this.renderOpts();
    this.updateSelectedVariant();
  },
  renderPrice(){
    const p = this.state.product;
    const v = this.currentVariant();
    const price = (v?v.price:p.price);
    const compare = (v?v.compare_at_price:p.compare_at_price);
    const el = $('[data-qv-price]', this.el);
    if(compare && compare > price){
      const off = Math.round((compare-price)/compare*100);
      el.innerHTML = `<span class="sale">${CRESTmoney(price)}</span> <del>${CRESTmoney(compare)}</del> <span class="save" style="background:var(--c-sale-bg);color:var(--c-sale-fg);font-size:.66rem;padding:.22rem .5rem;letter-spacing:.12em;text-transform:uppercase;border-radius:var(--radius);font-weight:600">Save ${off}%</span>`;
    } else {
      el.innerHTML = `<span>${CRESTmoney(price)}</span>`;
    }
  },
  renderOpts(){
    const p = this.state.product; const box = $('[data-qv-opts]', this.el);
    box.innerHTML = '';
    if(!p.options || p.options.length === 0) return;
    p.options.forEach((name,i)=>{
      const dn = name.toLowerCase();
      const isColor = dn.includes('color') || dn.includes('colour');
      const values = [...new Set(p.variants.map(v=>v.options[i]))];
      const wrap = document.createElement('div');
      wrap.className = 'pdp__opt';
      wrap.innerHTML = `
        <div class="pdp__opt-label"><span>${name}</span><strong data-qv-selected="${name}">${this.state.selected[name]||''}</strong></div>
        <div class="${isColor?'swatch-pills':'opt-pills'}"></div>
      `;
      const pills = wrap.querySelector('div + div');
      values.forEach(v=>{
        const variant = p.variants.find(x=>x.options[i]===v);
        const sold = variant && variant.available === false;
        const b = document.createElement('button');
        b.type='button'; b.setAttribute('role','radio');
        b.setAttribute('aria-checked', this.state.selected[name]===v ? 'true':'false');
        b.dataset.qvOpt='1'; b.dataset.optName=name; b.dataset.optVal=v;
        if(sold) b.setAttribute('data-soldout','');
        if(isColor){ b.setAttribute('aria-label', v); b.innerHTML=`<span style="background:${v.toLowerCase()}"></span>` }
        else { b.textContent = v }
        pills.appendChild(b);
      });
      box.appendChild(wrap);
    });
  },
  currentVariant(){
    const p = this.state.product; if(!p) return null;
    return p.variants.find(v => p.options.every((n,i)=> v.options[i] === this.state.selected[n]));
  },
  updateSelectedVariant(){
    const v = this.currentVariant();
    const btn = $('[data-qv-atc]', this.el);
    if(!v){ btn.disabled = true; btn.textContent = 'Unavailable'; return }
    btn.disabled = !v.available;
    btn.textContent = v.available ? 'Add to bag' : 'Sold out';
    this.renderPrice();
    // update image to variant image if present
    if(v.featured_image && v.featured_image.src){
      $('[data-qv-image]', this.el).src = v.featured_image.src.replace(/\.(jpg|jpeg|png|webp)/i, '_720x.$1');
    }
    // update selected label
    this.state.product.options.forEach(n=>{
      const el = this.el.querySelector(`[data-qv-selected="${n}"]`);
      if(el) el.textContent = this.state.selected[n]||'';
    });
  },
  async add(){
    const v = this.currentVariant(); if(!v || !v.available) return;
    const btn = $('[data-qv-atc]', this.el);
    btn.disabled = true; btn.textContent = 'Adding…';
    const ok = await cartDrawer.add(v.id, 1);
    if(ok){
      btn.textContent = 'Added ✓';
      setTimeout(()=>{ this.close(); btn.textContent = 'Add to bag'; btn.disabled=false; }, 900);
    } else {
      btn.textContent = 'Sold out';
      setTimeout(()=>{ btn.textContent = 'Add to bag'; btn.disabled=false; }, 1200);
    }
  }
};
qvModal.init();

document.addEventListener('click',(e)=>{
  const t = e.target.closest('[data-quick-view]'); if(!t) return;
  e.preventDefault(); e.stopPropagation();
  qvModal.open(t.dataset.productHandle);
});

/* ——— Filter/sort URL updates (collection page) */
(function collectionToolsInit(){
  const sort = $('[data-collection-sort]'); if(!sort) return;
  on(sort,'change',()=>{
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    location.href = url.toString();
  });
})();

})();
